// @ts-check
// Logotipo e símbolo do Matrícula Mais (identidade visual 3.1.0). Os arquivos ficam em client/public/brand, os mesmos
// dos e-mails do sistema. O logotipo traz as duas versões e o CSS mostra a do tema (brand.css); `tone` fixa uma delas
// quando o fundo não acompanha o tema, como o painel marinho da tela de acesso.
import { html } from 'htm/preact';

// ?v=2 desde o símbolo em traço de giz (outubro de 2026): o navegador não reaproveita o desenho antigo do cache
export const BRAND_LOGO_BLUE_URL = '/brand/logo-blue.svg?v=2';
export const BRAND_LOGO_WHITE_URL = '/brand/logo-white.svg?v=2';
export const BRAND_ICON_URL = '/brand/icon.svg?v=2';

// proporção do logotipo (largura sobre altura) no arquivo da marca
const LOGO_ASPECT_RATIO = 433.59 / 70.33;

/**
 * @param {{ height?: number, label?: string, tone?: 'theme' | 'light' | 'dark', className?: string }} props
 *   `label` vazio deixa a imagem decorativa (o texto ao lado já diz o nome).
 */
export function BrandLogo({ height = 20, label = '', tone = 'theme', className = '' }) {
  const width = Math.round(height * LOGO_ASPECT_RATIO);
  const size = { width, height, style: { width: `${width}px`, height: `${height}px` } };
  if (tone !== 'theme') {
    const source = tone === 'dark' ? BRAND_LOGO_WHITE_URL : BRAND_LOGO_BLUE_URL;
    return html`<img class=${`brand-logo ${className}`.trim()} src=${source} alt=${label} ...${size} />`;
  }
  return html`<span class=${`brand-logo brand-logo-themed ${className}`.trim()} role=${label ? 'img' : undefined} aria-label=${label || undefined}>
    <img class="brand-logo-on-light" src=${BRAND_LOGO_BLUE_URL} alt="" ...${size} />
    <img class="brand-logo-on-dark" src=${BRAND_LOGO_WHITE_URL} alt="" ...${size} />
  </span>`;
}

/** Símbolo do Matrícula Mais: o "+" fragmentado sobre o quadrado lima, decorativo. */
export function BrandMark({ size = 32 }) {
  return html`<img class="brand-mark" src=${BRAND_ICON_URL} alt="" width=${size} height=${size} style=${{ width: `${size}px`, height: `${size}px` }} />`;
}
